import gql from 'graphql-tag'

export const GET_BANKACCOUNTS = gql`
  query ($page: Int, $perPage: Int)  {
    bankAccounts (page: $page, perPage: $perPage)  {
      nodes {
        id
        bank
        accountName
        account
        accountBranch
      }
    }
  }
`

export default {
  GET_BANKACCOUNTS
}
